import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.75 1.875h22.5a1.877 1.877 0 0 1 1.875 1.875v22.5a1.88 1.88 0 0 1-1.875 1.875H3.75a1.877 1.877 0 0 1-1.875-1.875V3.75A1.877 1.877 0 0 1 3.75 1.875m9.375 8.438H26.25V3.75H13.125zm-1.875 0V3.75h-7.5v6.563zm-7.5 1.874V26.25h22.502l-.001-14.062zm6.563 12.188a4.693 4.693 0 0 1-4.688-4.687H7.5a2.812 2.812 0 1 0 2.813-2.813V15a4.688 4.688 0 0 1 0 9.375M18.75 15h1.875v9.375H18.75zm3.75 4.688h1.875v4.687H22.5z",
      "clip-rule": "evenodd"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }